import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dialog"
export default class extends Controller {
  static values = {
    url: String,
    autoOpen: { type: Boolean, default: true }
  }

  connect () {
    if (this.autoOpenValue) {
      setTimeout(() => {
        this.openModal();
      }, 0)
    }

    this.element.addEventListener("click", this.closeOnBackdropClick.bind(this));
  }
  open (evt) {
    evt.preventDefault()
    this.element.show()
  }

  openModal (evt) {
    this.element.showModal()
  }

  closeOnBackdropClick(evt) {
    // console.log('dialog clicked', evt.target, this.element)
    if (evt.target === this.element) {
      this.close();
    }
  }

  close (evt) {
    this.element.close()
  }

  focus() {}
}
